import { fg } from '@atlaskit/platform-feature-flags';
import { abortUFOMeasurementOnFirstUserInteraction } from './pm-plugins/abortUFOMeasurementOnFirstUserInteraction';
var isSSR = Boolean(process.env.REACT_SSR);
export var ufoPlugin = function ufoPlugin() {
  return {
    name: 'ufo',
    pmPlugins: function pmPlugins() {
      // We don't need to use this code for Serve Side Rendering
      if (isSSR || !fg('platform_editor_abort_ttvc_on_user_interaction')) {
        return [];
      }
      return [{
        name: 'abortUFOMeasurementOnFirstUserInteraction',
        plugin: abortUFOMeasurementOnFirstUserInteraction
      }];
    }
  };
};